import { render, staticRenderFns } from "./myProgramPackPage.vue?vue&type=template&id=518e16e1&scoped=true&"
import script from "./myProgramPackPage.vue?vue&type=script&lang=ts&"
export * from "./myProgramPackPage.vue?vue&type=script&lang=ts&"
import style0 from "./myProgramPackPage.vue?vue&type=style&index=0&id=518e16e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e16e1",
  null
  
)

export default component.exports